import React, { useState } from 'react';
import { ShowcaseSection, ShowcaseItem } from '../ShowcaseItem';
import { Button } from '@/components/ui/button';
import { ButtonGroup } from '@/components/ui/button-group';
import { Badge, BadgeGroup } from '@/components/ui/badge';
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter, CardKpiGrid, CardKpi, CardKpiTitle, CardProgressWrapper } from '@/components/ui/card';
import { CardMetric, CardMetricWrapper, CardMetricHeader, CardMetricTitle, CardMetricBody, CardMetricValue } from '@/components/ui/card-metric';
import { CardAvatarStack } from '@/components/ui/card-avatar-stack';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';
import {
  CourseCard,
  CourseCardImgWrapper,
  CourseCardImg,
  CourseCardHeader,
  CourseCardInnerHeader,
  CourseCardTitle,
  CourseCardSubtitle,
  CourseCardBody,
  CourseCardContent,
  CourseCardNotifications,
  CourseBanner,
  CourseBannerContent,
  CourseBannerContainer,
  CourseBannerHat,
  CourseBannerTitle,
  CourseBannerDescription,
  CourseBannerCTA,
  CourseCardAdminWrapper,
  CourseCardAdmin,
  CourseCardAdminImageWrapper,
  CourseCardAdminImage,
  CourseCardAdminContent,
  CourseCardAdminHeader,
  CourseCardAdminHeaderContent,
  CourseCardAdminTitle,
  CourseCardAdminBody,
  CourseCardAdminFooter,
  CourseCardAdminRating
} from '@/components/custom/course';
import { ModuleCardWrapper, ModuleCard, ModuleCardHeader, ModuleCardHeaderContent, ModuleCardTitle, ModuleCardSubtitle, ModuleCardText } from '@/components/custom/module/module-card';
import { LiveClassCard, LiveClassCardHeader, LiveClassCardHeaderInner, LiveClassCardTitle, LiveClassCardBody, LiveClassCardTime, LiveClassCardFooter } from '@/components/custom/live-class/live-class-card';
import { ProjectCard, ProjectCardHeader, ProjectCardFile, ProjectCardFileTitle } from '@/components/custom/project/project-card';
import { ProjectTimeline, ProjectTimelineItem, ProjectTimelineVersion, ProjectTimelineGroup, ProjectTimelineText } from '@/components/custom/project/project-timeline';
import { EssayCardTimelineWrapper, EssayCardTimeline, EssayCardTimelinePosition, EssayCardTimelineDescription, EssayCardTimelineScore, EssayCardTimelineScoreValue } from '@/components/custom/essay/essay-card-timeline';
import { SkillCardWrapper, SkillCard, SkillCardLevel } from '@/components/custom/skill/skill-card';
import { SubjectCard, SubjectCardHeader, SubjectCardVideo, SubjectCardBody, SubjectCardBodyHeader, SubjectCardTitle, SubjectCardTextScheduleWrapper, SubjectCardTextSchedule } from '@/components/custom/subject/subject-card';
import { WarningWall } from '@/components/custom/warning-wall/warning-wall';
import { IconVerified } from '@/components/custom/icon';
import { MedalContainer } from '@/components/custom/medal';
import { NotificationItemIcon, NotificationsBadge } from '@/components/custom/notifications';
import { Progress } from '@/components/custom/progress/progress';
import { FiChevronDown, FiClipboard, FiClock, FiEdit3, FiFile, FiStar, FiUsers, FiVideo } from 'react-icons/fi';
import { PiStudent } from 'react-icons/pi';
import { TbCopy } from 'react-icons/tb';
import { AiOutlineTrophy } from 'react-icons/ai';

const FAKE_USERS = [
  { id: '1', name: 'Ana Silva', image: { url: 'https://i.pravatar.cc/150?img=1' } },
  { id: '2', name: 'Bruno Santos', image: { url: 'https://i.pravatar.cc/150?img=2' } },
  { id: '3', name: 'Carla Oliveira', image: { url: 'https://i.pravatar.cc/150?img=3' } },
  { id: '4', name: 'Daniel Costa', image: { url: 'https://i.pravatar.cc/150?img=4' } },
  { id: '5', name: 'Elisa Almeida', image: { url: 'https://i.pravatar.cc/150?img=5' } },
  { id: '6', name: 'Fabio Mendes', image: { url: 'https://i.pravatar.cc/150?img=6' } }
];

export function CardsSection() {
  const [published, setPublished] = useState(true);

  return (
    <ShowcaseSection
      id="cards"
      title="Cards"
      description="Cartoes do dominio educacional, conforme aparecem no app"
    >
      <ShowcaseItem
        label="Card"
        description="Card base com header, content, footer"
      >
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          <Card>
            <CardHeader>
              <CardTitle>Default</CardTitle>
              <CardDescription>Descricao secundaria</CardDescription>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-neutral-dark">Conteudo do card.</p>
            </CardContent>
            <CardFooter>
              <Button size="sm">Acao</Button>
            </CardFooter>
          </Card>
          <Card hover>
            <CardHeader>
              <CardTitle>Com Hover</CardTitle>
              <CardDescription>Passe o mouse</CardDescription>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-neutral-dark">Card interativo.</p>
            </CardContent>
          </Card>
          <Card border>
            <CardHeader>
              <CardTitle>Com Borda</CardTitle>
              <CardDescription>Variante com borda visivel</CardDescription>
            </CardHeader>
            <CardContent>
              <Badge variant="success">Ativo</Badge>
            </CardContent>
          </Card>
        </div>
      </ShowcaseItem>

      <ShowcaseItem
        label="CardMetric"
        description="9 variantes de cartao de metrica"
      >
        <CardMetricWrapper>
          {['light', 'monochrome', 'primary', 'secondary', 'success', 'danger', 'warning', 'info', 'outline'].map(v => (
            <CardMetric
              key={v}
              variant={v}
            >
              <CardMetricHeader>
                <CardMetricTitle>{v}</CardMetricTitle>
              </CardMetricHeader>
              <CardMetricBody>
                <CardMetricValue>1.234</CardMetricValue>
              </CardMetricBody>
            </CardMetric>
          ))}
        </CardMetricWrapper>
      </ShowcaseItem>

      <ShowcaseItem
        label="CardAvatarStack"
        description="Pilha de avatares com truncate (clique abre Sheet com lista)"
      >
        <div className="flex flex-wrap items-center gap-8">
          <CardAvatarStack
            data={FAKE_USERS}
            modalTitle="Participantes"
            truncateIn={3}
            size="sm"
          />
          <CardAvatarStack
            data={FAKE_USERS.slice(0, 4)}
            modalTitle="Equipe"
            truncateIn={4}
            size="default"
          />
        </div>
      </ShowcaseItem>

      <ShowcaseItem
        label="CourseCard (dashboard)"
        description="Cartao de curso completo: imagem, IconVerified, titulo, notificacoes, medalha de conclusao, progresso ou badge 'Concluido'"
      >
        <div className="grid gap-4 lg:grid-cols-2">
          {/* In progress */}
          <CourseCard>
            <CourseCardBody alignment="home">
              <CourseCardImgWrapper>
                <CourseCardImg
                  size="md"
                  src=""
                  alt=""
                />
              </CourseCardImgWrapper>
              <CourseCardContent>
                <CourseCardHeader>
                  <CourseCardInnerHeader>
                    <div className="flex items-start gap-1.5">
                      <IconVerified />
                      <CourseCardTitle>Matematica para o ENEM</CourseCardTitle>
                    </div>
                    <CourseCardSubtitle>34/48 aulas concluidas</CourseCardSubtitle>
                  </CourseCardInnerHeader>
                  <CourseCardNotifications>
                    <NotificationItemIcon
                      variant="warning"
                      size="sm"
                    >
                      <FiClipboard />
                      <NotificationsBadge>3</NotificationsBadge>
                    </NotificationItemIcon>
                    <NotificationItemIcon
                      variant="warning"
                      size="sm"
                    >
                      <FiEdit3 />
                      <NotificationsBadge>1</NotificationsBadge>
                    </NotificationItemIcon>
                  </CourseCardNotifications>
                </CourseCardHeader>
                <div>
                  <CardProgressWrapper
                    percentage={70}
                    toFixed={0}
                  />
                </div>
              </CourseCardContent>
            </CourseCardBody>
          </CourseCard>

          {/* Completed with medal */}
          <CourseCard>
            <CourseCardBody alignment="home">
              <CourseCardImgWrapper>
                <CourseCardImg
                  size="md"
                  src=""
                  alt=""
                />
              </CourseCardImgWrapper>
              <CourseCardContent>
                <CourseCardHeader>
                  <CourseCardInnerHeader>
                    <div className="flex items-start gap-1.5">
                      <CourseCardTitle>Historia do Brasil</CourseCardTitle>
                    </div>
                    <CourseCardSubtitle>32/32 aulas concluidas</CourseCardSubtitle>
                  </CourseCardInnerHeader>
                  <MedalContainer
                    size="sm"
                    src="more"
                    value={<AiOutlineTrophy />}
                  />
                </CourseCardHeader>
                <div>
                  <Badge
                    variant="success"
                    size="xs"
                  >
                    Concluido
                  </Badge>
                </div>
              </CourseCardContent>
            </CourseCardBody>
          </CourseCard>
        </div>
      </ShowcaseItem>

      <ShowcaseItem
        label="CourseCardAdmin"
        description="Visao admin: IconVerified, FormSwitch 'Publicar', CardKpiGrid (Estudantes + Modulos), Rating + ButtonGroup com DropdownMenu"
      >
        <CourseCardAdminWrapper>
          <CourseCardAdmin>
            <CourseCardAdminImageWrapper>
              <CourseCardAdminImage
                src=""
                alt="curso"
              />
            </CourseCardAdminImageWrapper>
            <CourseCardAdminContent>
              <CourseCardAdminHeader>
                <CourseCardAdminHeaderContent>
                  <IconVerified />
                  <CourseCardAdminTitle>Matematica para o ENEM</CourseCardAdminTitle>
                </CourseCardAdminHeaderContent>
                <div className="flex items-center gap-2">
                  <Switch
                    checked={published}
                    onCheckedChange={setPublished}
                  />
                  <Label className="text-sm">Publicar</Label>
                </div>
              </CourseCardAdminHeader>

              <CourseCardAdminBody>
                <CardKpiGrid>
                  <CardKpi>
                    <CardKpiTitle>Estudantes</CardKpiTitle>
                    <PiStudent
                      size={20}
                      className="text-primary"
                    />{' '}
                    240
                  </CardKpi>
                  <CardKpi clickable>
                    <CardKpiTitle>Modulos publicados</CardKpiTitle>
                    <TbCopy
                      size={20}
                      className="text-primary"
                    />{' '}
                    8
                  </CardKpi>
                </CardKpiGrid>
              </CourseCardAdminBody>

              <CourseCardAdminFooter>
                <CourseCardAdminRating>
                  <FiStar /> 4.8 <span>(120)</span>
                </CourseCardAdminRating>

                <ButtonGroup className="w-full">
                  <Button
                    variant="outline"
                    size="sm"
                    fullWidth
                  >
                    Visualizar
                  </Button>
                  <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                      <Button
                        variant="outline"
                        size="sm"
                      >
                        <FiChevronDown size={20} />
                      </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent align="end">
                      <DropdownMenuItem>Editar</DropdownMenuItem>
                      <DropdownMenuItem>Excluir</DropdownMenuItem>
                      <DropdownMenuItem>Ver metricas</DropdownMenuItem>
                      <DropdownMenuItem>Gerenciar conteudo</DropdownMenuItem>
                    </DropdownMenuContent>
                  </DropdownMenu>
                </ButtonGroup>
              </CourseCardAdminFooter>
            </CourseCardAdminContent>
          </CourseCardAdmin>
        </CourseCardAdminWrapper>
      </ShowcaseItem>

      <ShowcaseItem
        label="CourseBanner"
        description="Banner de curso com imagem de fundo + overlay escuro"
      >
        <CourseBanner backgroundUrl="https://images.unsplash.com/photo-1497486751825-1233686d5d80?w=1200">
          <CourseBannerContent>
            <CourseBannerContainer>
              <CourseBannerHat>CURSO PREMIUM</CourseBannerHat>
              <CourseBannerTitle>Preparatorio para Vestibular 2026</CourseBannerTitle>
              <CourseBannerDescription>Curso completo com aulas ao vivo, simulados e materiais exclusivos para sua aprovacao.</CourseBannerDescription>
              <CourseBannerCTA>
                <Button variant="primary-light">Inscrever-se</Button>
                <Button
                  variant="ghost"
                  className="text-white hover:text-white"
                >
                  Saiba mais
                </Button>
              </CourseBannerCTA>
            </CourseBannerContainer>
          </CourseBannerContent>
        </CourseBanner>
      </ShowcaseItem>

      <ShowcaseItem
        label="ModuleCard (course-monitoring)"
        description="IconVerified + BadgeGroup status + texto progresso + medalha (se 100%) + Button Acessar"
      >
        <ModuleCardWrapper>
          {[
            { title: 'Frações e Numeros Decimais', subtitle: '8 aulas · 2h30min', status: 'Em andamento', variant: 'warning', progress: '4/8 aulas', completed: false },
            { title: 'Equações de 1º Grau', subtitle: '6 aulas · 1h45min', status: 'Novo', variant: 'warning', progress: '0/6 aulas', completed: false },
            { title: 'Geometria Plana', subtitle: '10 aulas · 3h15min', status: 'Concluído', variant: 'success', progress: '10/10 aulas', completed: true }
          ].map(mod => (
            <ModuleCard key={mod.title}>
              <ModuleCardHeader className="w-[350px]">
                <ModuleCardHeaderContent>
                  <div className="flex items-start gap-1">
                    <IconVerified />
                    <ModuleCardTitle title={mod.title}>{mod.title}</ModuleCardTitle>
                  </div>
                  <ModuleCardSubtitle>{mod.subtitle}</ModuleCardSubtitle>
                </ModuleCardHeaderContent>
              </ModuleCardHeader>

              <BadgeGroup>
                <Badge
                  variant={mod.variant}
                  size="xs"
                >
                  {mod.status}
                </Badge>
              </BadgeGroup>

              <ModuleCardText>{mod.progress}</ModuleCardText>

              {mod.completed && (
                <MedalContainer
                  size="sm"
                  src="more"
                  value={<AiOutlineTrophy />}
                />
              )}

              <Button
                variant="outline"
                wide
                className="hidden sm:flex"
              >
                Acessar
              </Button>
            </ModuleCard>
          ))}
        </ModuleCardWrapper>
      </ShowcaseItem>

      <ShowcaseItem
        label="LiveClassCard"
        description="Cartao de aula ao vivo com badge AO VIVO e tempo"
      >
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {[
            { title: 'Revisao de Algebra', time: 'Hoje, 19:00', body: 'Resolução de exercicios da prova passada.' },
            { title: 'Quimica Organica', time: 'Amanha, 14:00', body: 'Introducao aos hidrocarbonetos.' },
            { title: 'Redacao Dissertativa', time: '15/04, 16:00', body: 'Como construir argumentos solidos.' }
          ].map(live => (
            <LiveClassCard key={live.title}>
              <LiveClassCardHeader>
                <LiveClassCardHeaderInner>
                  <LiveClassCardTitle>{live.title}</LiveClassCardTitle>
                  <Badge
                    variant="primary-light"
                    size="xs"
                  >
                    AO VIVO
                  </Badge>
                </LiveClassCardHeaderInner>
                <LiveClassCardTime>
                  <FiClock size={12} /> {live.time}
                </LiveClassCardTime>
              </LiveClassCardHeader>
              <LiveClassCardBody>{live.body}</LiveClassCardBody>
              <LiveClassCardFooter>
                <Button
                  size="sm"
                  fullWidth
                >
                  <FiVideo size={14} /> Entrar
                </Button>
              </LiveClassCardFooter>
            </LiveClassCard>
          ))}
        </div>
      </ShowcaseItem>

      <ShowcaseItem
        label="ProjectCard"
        description="Cartao de projeto com lista de arquivos"
      >
        <ProjectCard>
          <ProjectCardHeader>
            <FiUsers
              size={20}
              className="text-primary"
            />
            <h3 className="m-0 text-sm font-bold text-primary-dark">Projeto: Pesquisa em Saude Publica</h3>
          </ProjectCardHeader>
          <ProjectCardFile>
            <FiFile
              size={16}
              className="text-neutral-dark"
            />
            <ProjectCardFileTitle>relatorio-final.pdf</ProjectCardFileTitle>
          </ProjectCardFile>
          <ProjectCardFile>
            <FiFile
              size={16}
              className="text-neutral-dark"
            />
            <ProjectCardFileTitle>apresentacao.pptx</ProjectCardFileTitle>
          </ProjectCardFile>
        </ProjectCard>
      </ShowcaseItem>

      <ShowcaseItem
        label="ProjectTimeline"
        description="Linha do tempo de versoes de projeto"
      >
        <ProjectTimeline>
          <ProjectTimelineItem approved>
            <ProjectTimelineVersion>v3</ProjectTimelineVersion>
            <ProjectTimelineGroup>
              <ProjectTimelineText>Versao final aprovada</ProjectTimelineText>
            </ProjectTimelineGroup>
          </ProjectTimelineItem>
          <ProjectTimelineItem active>
            <ProjectTimelineVersion>v2</ProjectTimelineVersion>
            <ProjectTimelineGroup>
              <ProjectTimelineText>Em revisao</ProjectTimelineText>
            </ProjectTimelineGroup>
          </ProjectTimelineItem>
          <ProjectTimelineItem>
            <ProjectTimelineVersion>v1</ProjectTimelineVersion>
            <ProjectTimelineGroup>
              <ProjectTimelineText>Submissao inicial</ProjectTimelineText>
            </ProjectTimelineGroup>
          </ProjectTimelineItem>
        </ProjectTimeline>
      </ShowcaseItem>

      <ShowcaseItem
        label="EssayCardTimeline"
        description="Timeline de redacoes com score colorido por variante (success/warning/danger)"
      >
        <EssayCardTimelineWrapper>
          <EssayCardTimeline isActive>
            <EssayCardTimelinePosition isActive>1</EssayCardTimelinePosition>
            <EssayCardTimelineDescription>
              <strong>Tema: Desigualdade Social</strong>
              <span className="text-xs text-neutral">Submetida em 10/04</span>
            </EssayCardTimelineDescription>
            <EssayCardTimelineScore variant="success">
              <EssayCardTimelineScoreValue>920</EssayCardTimelineScoreValue>
              <span className="text-[10px]">/ 1000</span>
            </EssayCardTimelineScore>
          </EssayCardTimeline>
          <EssayCardTimeline>
            <EssayCardTimelinePosition>2</EssayCardTimelinePosition>
            <EssayCardTimelineDescription>
              <strong>Tema: Meio Ambiente</strong>
              <span className="text-xs text-neutral">Submetida em 03/04</span>
            </EssayCardTimelineDescription>
            <EssayCardTimelineScore variant="warning">
              <EssayCardTimelineScoreValue>720</EssayCardTimelineScoreValue>
              <span className="text-[10px]">/ 1000</span>
            </EssayCardTimelineScore>
          </EssayCardTimeline>
          <EssayCardTimeline>
            <EssayCardTimelinePosition>3</EssayCardTimelinePosition>
            <EssayCardTimelineDescription>
              <strong>Tema: Tecnologia</strong>
              <span className="text-xs text-neutral">Submetida em 27/03</span>
            </EssayCardTimelineDescription>
            <EssayCardTimelineScore variant="danger">
              <EssayCardTimelineScoreValue>540</EssayCardTimelineScoreValue>
              <span className="text-[10px]">/ 1000</span>
            </EssayCardTimelineScore>
          </EssayCardTimeline>
        </EssayCardTimelineWrapper>
      </ShowcaseItem>

      <ShowcaseItem
        label="SubjectCard"
        description="Cartao de materia com video thumbnail + titulo + progresso"
      >
        <SubjectCard>
          <SubjectCardHeader>
            <SubjectCardVideo>
              <img
                src="https://images.unsplash.com/photo-1635070041078-e363dbe005cb?w=400"
                alt="thumb"
                className="absolute h-full w-full object-cover"
              />
            </SubjectCardVideo>
            <SubjectCardTextScheduleWrapper>
              <SubjectCardTextSchedule>Aula 03</SubjectCardTextSchedule>
              <SubjectCardTextSchedule>14/04 19:00</SubjectCardTextSchedule>
            </SubjectCardTextScheduleWrapper>
          </SubjectCardHeader>
          <SubjectCardBody>
            <SubjectCardBodyHeader>
              <SubjectCardTitle>Algebra Linear — Vetores e Matrizes</SubjectCardTitle>
            </SubjectCardBodyHeader>
            <Progress
              valueNow={65}
              showText
            />
          </SubjectCardBody>
        </SubjectCard>
      </ShowcaseItem>

      <ShowcaseItem
        label="WarningWall"
        description="Banner hero horizontal com imagem + titulo + descricao + CTA (texto)"
      >
        <WarningWall
          warning={{
            title: 'Bem-vindo ao novo modulo de IA',
            description: 'Conheca a nova funcionalidade de tutoria com inteligencia artificial. Tire duvidas, receba explicacoes personalizadas e melhore seus estudos.',
            link: 'https://exemplo.com',
            label: 'Saber mais'
          }}
        />
      </ShowcaseItem>

      <ShowcaseItem
        label="WarningWall — apenas imagem"
        description="Variante so com banner (image + link sem texto)"
      >
        <WarningWall
          warning={{
            image: { url: 'https://images.unsplash.com/photo-1497486751825-1233686d5d80?w=1200&h=260&fit=crop' },
            link: 'https://exemplo.com',
            label: 'Acessar'
          }}
        />
      </ShowcaseItem>

      <ShowcaseItem
        label="SkillCard"
        description="Cartoes de habilidades em grid responsivo"
      >
        <SkillCardWrapper>
          {[
            { name: 'Logica Matematica', level: 'Nivel 4 de 5' },
            { name: 'Interpretacao de Texto', level: 'Nivel 3 de 5' },
            { name: 'Pensamento Critico', level: 'Nivel 5 de 5' }
          ].map(skill => (
            <SkillCard key={skill.name}>
              <h3 className="m-0 text-base font-bold text-primary-dark">{skill.name}</h3>
              <p className="m-0 text-sm text-neutral">Habilidade desenvolvida ao longo do curso.</p>
              <SkillCardLevel>
                <span className="text-xs font-bold text-primary">{skill.level}</span>
              </SkillCardLevel>
            </SkillCard>
          ))}
        </SkillCardWrapper>
      </ShowcaseItem>
    </ShowcaseSection>
  );
}
